





























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import BackendAvailabilityService from '@/api/BackendAvailability';
import FlagService from '@/api/FlagService';
import MaintenanceKeys from '@/constants/maintenance';

import { sendEventHotjarByTypeAndDescription } from '@/utils/hotjar';
import {
  IHotjarEventDescritpion,
  IHotjarEventType
} from '@/models/hotjar-options';

import segmentIo, { addSegmentScript } from '@/utils/segment.io';
import { injectZendeskScript } from '@/utils/zendesk';

let timer: NodeJS.Timeout;
const POLLING_TIME = 15000; // 15s

@Component({
  components: {
    TwismLogoIcon
  }
})
export default class Maintenance extends Vue {
  @Prop() featureFlags!: string[];

  flagService = new FlagService();
  backendAvailabilityService = new BackendAvailabilityService();

  mounted() {
    injectZendeskScript();
    addSegmentScript({
      featureFlags: this.featureFlags
    });
    this.checkBackendStatus();

    segmentIo.page('Maintenance');

    sendEventHotjarByTypeAndDescription({
      typeEvent: IHotjarEventType.WARNING,
      description: IHotjarEventDescritpion.MAINTANCE_PAGE
    });
  }

  beforeDestroy() {
    if (timer) clearTimeout(timer);
  }

  handleMaintenanceRedirect() {
    if (location.pathname !== '/maintenance') {
      location.reload();

      return;
    }

    const lastRouteBeforeMaintenance = localStorage.getItem(
      MaintenanceKeys.LAST_ROUTE_BEFORE_MAINTENANCE_STORAGE_KEY
    );

    this.$router.push(lastRouteBeforeMaintenance || '/');
    localStorage.removeItem(
      MaintenanceKeys.LAST_ROUTE_BEFORE_MAINTENANCE_STORAGE_KEY
    );
  }

  async getFlags() {
    let items = "['']";

    try {
      const flagResponse = await this.flagService.getFlags();
      items = JSON.stringify(flagResponse.data.items);

      return {
        success: true,
        data: flagResponse.data.items
      };
    } catch {
      return {
        success: false,
        data: []
      };
    } finally {
      sessionStorage.setItem('dashboard-flags', items);
    }
  }

  async checkBackendStatus() {
    try {
      const { data: flags } = await this.getFlags();

      const {
        available: backendIsAvailable
      } = await this.backendAvailabilityService.getStatus(flags);

      if (!backendIsAvailable) return;

      this.handleMaintenanceRedirect();
    } finally {
      timer = setTimeout(this.checkBackendStatus, POLLING_TIME);
    }
  }
}
